<template>
  <v-data-table
    :headers="headers"
    :items="westnetData"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Westnet</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" width="1000px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              Registrar nuevo equipo
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.num_router"
                      label="Num de Router"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-select
                      :items="namesObject"
                      v-model="editedItem.asignado"
                      label="Asignado a "
                       :value="selectedOption"
                      @change="addAsignado(editedItem.asignado)"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.metros_drop"
                      label="Metros de Drop"
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.conectores"
                      label="Conectores"
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.num_cliente"
                      label="Número de Cliente"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.num_ticket"
                      label="Número de ticket"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-container class="px-0" fluid>
                      <v-switch
                        v-model="editedItem.estado"
                        :label="`ASIGNADO`"
                        false-value="LIBRE"
                        true-value="ASIGNADO"
                      ></v-switch>
                    </v-container>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    v-if="editedItem.estado === 'ASIGNADO'"
                  >
                    <v-select
                      :items="optionsTipo"
                      v-model="selectedOptionTipo"
                      label="Tipo de trabajo"
                      @change="addTipo(selectedOptionTipo)"
                      dense
                    ></v-select>
                    <!-- <p style="color:red; font-size:14px">Ingrese el tipo de trabajo realizado en la instalación</p> -->
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="save"> Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >¿Está seguro de borrar este item?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancelar</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.estado`]="{ item }">
      <v-chip class="ma-2">{{ item.estado }}</v-chip>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
      <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary"> Reset </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from "vuex";
import {
  getAllWestnet,
  addWestnet,
  updateWestnet,
  deleteWestnet,
  updateArray,
  deleteArray
} from "../database.js";
export default {
  name: "Optix",

  components: {},
  data: () => ({
    dialog: false,
    dialogDelete: false,
    // ASIGNADO: false,
    headers: [
      {
        text: "Num de Router",
        align: "start",
        sortable: false,
        value: "num_router",
      },
      { text: "Asignado a ", value: "asignado" },
      { text: "Metros de Drop", value: "metros_drop" },
      { text: "Conectores", value: "conectores" },
      { text: "Número de Cliente", value: "num_cliente" },
      { text: "Número de Ticket", value: "num_ticket" },
      { text: "Fecha de asignación", value: "fecha_asignacion" },
      { text: "Fecha de instalación", value: "fecha_instalacion" },
      { text: "Estado", value: "estado", sortable: false },
      { text: "Tipo de trabajo", value: "tipo", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    options: "",
    selectedOption: null,
    selectedOptionTipo: null,
    date: new Date(
      Date.now() - new Date().getTimezoneOffset() * 60000
    ).toLocaleDateString(),
    menu: false,
    optionsTipo: [
      { value: "Instalación", text: "Instalación" },
      { value: "Cambio de Tecnología", text: "Cambio de Tecnología" },
      { value: "Servicio técnico", text: "Servicio técnico" },
    ],
    editedIndex: -1,
    namesObject: [],
    editedItem: {
      num_router: "",
      num_cliente: "",
      num_ticket: "",
      metros_drop: "",
      conectores: "",
      asignado: "",
      fecha_asignacion: "",
      fecha_instalacion: "",
      tipo: "",
      estado: "LIBRE",
      id: "",
      idusuario:""      
    },
    defaultItem: {
      num_router: "",
      num_cliente: "",
      num_ticket: "",
      metros_drop: "",
      conectores: "",
      asignado: "",
      fecha_asignacion: "",
      fecha_instalacion: "",
      tipo: "",
      estado: "LIBRE",

    },
    iduser:"",
    tipo:"",
    router:""

    
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Registro" : "Editar Registro";
    },
    ...mapState({
      userlist: (state) => state.usersList,
      westnetData: (state) => state.westnetData,
      westnet: (state) => state.westnet,
     


    }),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async created() {
    // console.log("111", this.userlist);
    // console.log("11", this.date);
    // console.log("11111", this.ASIGNADO);
    await getAllWestnet();
    this.arrayToObject();
    // console.log("westnetData", this.westnetData);
  },

  methods: {
    editItem(item) {
      // console.log("item para editar", item);
      this.editedIndex = this.westnetData.indexOf(item);
      console.log("editedIndex", this.editedIndex);
      this.editedItem = Object.assign({}, item);



      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.westnetData.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      // console.log("borrando:", this.editedItem.id);
      await deleteWestnet(this.editedItem.id);
      this.westnetData.splice(this.editedIndex, 1);
      await getAllWestnet();
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedIndex > -1) {
        Object.assign(this.westnetData[this.editedIndex], this.editedItem);
        // console.log("111", this.editedItem);
        // console.log("itemid", this.westnetData);
        // console.log("editedItem", this.editedItem);
        this.editedItem.fecha_instalacion = this.date; 
        this.$store.dispatch("setWestnetData", this.editedItem);
        // console.log("optix: ", this.optix);        
        await updateWestnet(this.editedItem.id);
        if (this.editedItem.estado === "ASIGNADO") {
          // console.log("userlist",this.userlist)
          let foundObject = this.userlist.find((obj) => obj.iduser === this.editedItem.idusuario);
          console.log(foundObject)
          this.tipo ="en_uso"
          this.router=this.editedItem.num_router
          await updateArray(this.editedItem.idusuario,this.tipo , this.router )
          this.tipo ="libres"
          await deleteArray(this.editedItem.idusuario,this.tipo , this.router )
          if(this.editedItem.tipo === "Instalación"){
            this.tipo = "instalaciones"
            this.router=this.editedItem.num_router
          }
          if(this.editedItem.tipo === "Servicio técnico"){
            this.tipo = "servicio_tecnico"
            this.router=this.editedItem.num_router
          }
          if(this.editedItem.tipo === "Cambio de Tecnología"){
            this.tipo = "cambio_tecnologia"
            this.router=this.editedItem.num_router
          }
          // console.log("tipo: ", this.tipo)
          // console.log("router: ", this.router)
          // console.log(this.editedItem.idusuario)
     
          await updateArray(this.editedItem.idusuario,this.tipo , this.router )
        }
        await getAllWestnet();
      } else {       
        this.dialog = true;
        this.editedItem.fecha_asignacion = this.date;
        this.$store.dispatch("setWestnetData", this.editedItem);
        this.tipo = "libres"
        this.router = this.editedItem.num_router
        await updateArray(this.editedItem.idusuario,this.tipo, this.router )
        await addWestnet();
        await getAllWestnet();
      }
      this.close();
    },

    addAsignado(data) {
     
      this.editedItem.asignado = data;
      let name =this.userlist
      let foundObject = name.find((obj) => obj.nombre === data);
      // console.log("asignado: objeto", foundObject.id)
      this.editedItem.idusuario = foundObject.id
      // console.log(this.editedItem.idusuario)

    },
   
    addTipo(data) {
      this.editedItem.tipo = data;
      // console.log(this.editedItem.tipo);     
    },

    arrayToObject() {
     const names = this.userlist;
      this.namesObject = names.map(user => user.nombre);
      // console.log("edited asignado", this.namesObject)
       
    },
  },
};
</script>